// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__input___NnHSY {
  width: 250px !important;
}
.styles__diameters___oZTjR {
  display: flex;
}
.styles__checkbox___w0Unc {
  margin-right: 1em;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/Search/CompleteWheelSearch/SearchMode/styles.less"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;AAEA;EACE,aAAA;AAAF;AAGA;EACE,iBAAA;AADF","sourcesContent":[".input {\n  width: 250px !important;\n}\n\n.diameters {\n  display: flex;\n}\n\n.checkbox {\n  margin-right: 1em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `styles__input___NnHSY`,
	"diameters": `styles__diameters___oZTjR`,
	"checkbox": `styles__checkbox___w0Unc`
};
export default ___CSS_LOADER_EXPORT___;
